import React from 'react';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import './OrderSummary.styles.scss';

const OrderSummary = ({ center, serviceName }) => {
  const hasCenter = !!center;
  const charge = center?.charge;
  const priceDisplay = charge === 0 ? 'Free' : charge != null ? `₹${charge}` : '—';

  return (
    <div className="order-summary">
      <h2>
        <ReceiptOutlinedIcon className="order-summary__icon" />
        Order Summary
      </h2>
      <div className="order-item">
        <p className="order-item__name">{serviceName || '—'}</p>
        <p className="order-item__center">
          {hasCenter ? (
            <>
              <StorefrontOutlinedIcon className="order-item__center-icon" />
              {center.centerName}
            </>
          ) : '—'}
        </p>
        <p className="order-item__price">{priceDisplay}</p>
      </div>
      {hasCenter && (
        <div className="order-summary__meta">
          <LocationOnOutlinedIcon className="order-summary__meta-icon" />
          <span>{center.address}, {center.city}, {center.state} – {center.pincode}</span>
        </div>
      )}
    </div>
  );
};

export default OrderSummary;
